import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/app/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/app/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["mediaStyles"] */ "/usr/src/app/server/app/components/Media/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/app/components/Media/RootHead.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/app/components/Page/provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/app/components/SWRProvider.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/server/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/server/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/server/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/server/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../public/fonts/NN-Swinton-VF.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../public/fonts/NNSwinton-Regular.otf\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--swintonfont\"}],\"variableName\":\"swintonfont\"}");
;
import(/* webpackMode: "eager" */ "/usr/src/app/server/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../public/fonts/ABCDiatype-Heavy.otf\",\"weight\":\"800\",\"style\":\"normal\"}],\"variable\":\"--abcdfont\"}],\"variableName\":\"abcdfont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/usr/src/app/server/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ArtsyFresnel"] */ "/usr/src/app/server/providers/ArtsyFresnel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["msvcProxy"] */ "/usr/src/app/server/utils/clientSideProxy.ts");
